import Vue from "vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueGallery from 'vue-gallery';
import VTooltip from "v-tooltip";
import Vuex from "vuex";
import VueMoment from 'vue-moment';
import VSelect from "@base/VSelect";
import 'quill/dist/quill.snow.css';
import "vue-multiselect/dist/vue-multiselect.min.css";


import DatePiker from "@base/DatePicker.vue";
import VInput from "@base/VInput.vue";
import VQuill from "@base/VQuill.vue";
import DoctuTable from "@base/vuetable/DoctuTable.vue";
import DoctuTableRow from "@base/vuetable/DoctuTableRow.vue";
import DoctuTableCell from "@base/vuetable/DoctuTableCell.vue";
import DoctuTableHeaderCell from "@base/vuetable/DoctuTableHeaderCell.vue";
import VDialogOld from "@base/VDialogOld.vue";
import VDialog from "@base/VDialog.vue";
import DoctuTableSelectPeriod from "@base/vuetable/DoctuTableSelectPeriod";
import VLoadingComponent from "@base/VLoadingComponent";
import DateRangePicker from "@base/DateRangePicker";
import DoctuTableHeaderCellSimple from "@base/vuetable/DoctuTableHeaderCellSimple.vue";



Vue.use(VueAxios, axios);
let identifierMeta = document.querySelector("meta[name='identifier']");
if (identifierMeta) {
    axios.defaults.headers.common['AdditionalIdentifier'] = identifierMeta.getAttribute("content");
}
Vue.use(VTooltip, {defaultDelay: {show: 1500, hide: 150}, disposeTimeout:0});
Vue.prototype.$errTemplate = `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
Vue.use(Vuex);
Vue.use(VueMoment);

Vue.component('v-gallery', VueGallery);
Vue.component('v-select', VSelect);
Vue.component('v-quill', VQuill);

Vue.component('v-td', DoctuTableCell);
Vue.component('v-th', DoctuTableHeaderCell);
Vue.component('v-th-s', DoctuTableHeaderCellSimple);
Vue.component('v-tr', DoctuTableRow);
Vue.component('v-table', DoctuTable);
Vue.component('v-dialog-old', VDialogOld);
Vue.component('v-dialog', VDialog);
Vue.component('v-input', VInput);
Vue.component('v-select-period', DoctuTableSelectPeriod);
Vue.component('date-piker', DatePiker);
Vue.component('date-range-picker', DateRangePicker)
Vue.component('v-loading-component', VLoadingComponent);
